import { render, staticRenderFns } from "./SectionClientCourseBought.vue?vue&type=template&id=48c4e949&"
import script from "./SectionClientCourseBought.vue?vue&type=script&lang=js&"
export * from "./SectionClientCourseBought.vue?vue&type=script&lang=js&"
import style0 from "./SectionClientCourseBought.vue?vue&type=style&index=0&id=48c4e949&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports